import React, { useState } from 'react';
import { X, Mic, FileAudio, Play, Film } from 'lucide-react';
import VoiceRecorder from './VoiceRecorder';
import VoiceFileUpload from './VoiceFileUpload';
import VoiceYoutubeExtract from './VoiceYoutubeExtract';
import VoiceReelExtract from './VoiceReelExtract';
import VoiceResult from './VoiceResult';

const VoiceWidget = ({ onClose, onInjectToChat }) => {
  const [view, setView] = useState('menu'); // menu | recorder | file | youtube | reel | result
  const [resultText, setResultText] = useState('');
  const [resultLabel, setResultLabel] = useState('');

  const handleResult = (text, label) => {
    setResultText(text);
    setResultLabel(label);
    setView('result');
  };

  const menuItems = [
    { id: 'recorder', icon: <Mic size={20} />, title: 'Saisie vocale directe', desc: 'Enregistrer et transcrire en temps réel' },
    { id: 'file', icon: <FileAudio size={20} />, title: 'Importer un fichier audio', desc: 'MP3, WAV, M4A' },
    { id: 'youtube', icon: <Play size={20} />, title: 'URL YouTube', desc: 'Extraire et transcrire' },
    { id: 'reel', icon: <Film size={20} />, title: 'Reel / TikTok', desc: 'Facebook, TikTok, Instagram' },
  ];

  return (
    <div style={styles.overlay}>
      <div style={styles.widget}>
        {/* Header */}
        <div style={styles.header}>
          <div style={styles.headerLeft}>
            <span style={styles.dot} />
            <span style={styles.headerTitle}>ITRIIA Voice</span>
          </div>
          <button onClick={onClose} style={styles.closeBtn}><X size={18} /></button>
        </div>

        {/* Content */}
        <div style={styles.body}>
          {view === 'menu' && (
            <>
              <div style={styles.subtitle}>
                <span style={{ color: '#64748b', fontSize: 12 }}>Propulsé par</span>
                <span style={{ color: '#e2e8f0', fontSize: 14, fontWeight: 700, letterSpacing: 1 }}>ITRIIA VOICE</span>
              </div>
              {menuItems.map(item => (
                <button key={item.id} onClick={() => setView(item.id)} style={styles.menuCard}>
                  <div style={styles.menuIcon}>{item.icon}</div>
                  <div>
                    <div style={styles.menuTitle}>{item.title}</div>
                    <div style={styles.menuDesc}>{item.desc}</div>
                  </div>
                </button>
              ))}
            </>
          )}

          {view === 'recorder' && (
            <VoiceRecorder onResult={handleResult} onBack={() => setView('menu')} />
          )}

          {view === 'file' && (
            <VoiceFileUpload onResult={handleResult} onBack={() => setView('menu')} />
          )}

          {view === 'youtube' && (
            <VoiceYoutubeExtract onResult={handleResult} onBack={() => setView('menu')} />
          )}

          {view === 'reel' && (
            <VoiceReelExtract onResult={handleResult} onBack={() => setView('menu')} />
          )}

          {view === 'result' && (
            <VoiceResult
              text={resultText}
              label={resultLabel}
              onInjectToChat={onInjectToChat}
              onBack={() => setView('menu')}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'absolute',
    bottom: '100%',
    right: 0,
    marginBottom: 8,
    zIndex: 50,
  },
  widget: {
    width: 380,
    background: '#1e293b',
    borderRadius: 16,
    border: '1px solid #334155',
    boxShadow: '0 20px 60px rgba(0,0,0,0.5)',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '14px 18px',
    borderBottom: '1px solid #334155',
  },
  headerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    background: '#22c55e',
    display: 'inline-block',
  },
  headerTitle: {
    color: '#f1f5f9',
    fontSize: 15,
    fontWeight: 600,
  },
  closeBtn: {
    background: 'none',
    border: 'none',
    color: '#64748b',
    cursor: 'pointer',
    padding: 4,
  },
  body: {
    padding: 18,
  },
  subtitle: {
    textAlign: 'center',
    marginBottom: 20,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  menuCard: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: 14,
    padding: '14px 16px',
    background: '#334155',
    border: '1px solid #475569',
    borderRadius: 12,
    cursor: 'pointer',
    marginBottom: 10,
    transition: 'all 0.15s',
    textAlign: 'left',
  },
  menuIcon: {
    width: 44,
    height: 44,
    borderRadius: '50%',
    background: '#475569',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#94a3b8',
    flexShrink: 0,
  },
  menuTitle: {
    color: '#f1f5f9',
    fontSize: 14,
    fontWeight: 600,
    marginBottom: 2,
  },
  menuDesc: {
    color: '#94a3b8',
    fontSize: 12,
  },
};

export default VoiceWidget;
